import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ContentPath } from './content-path';
import { BreadcrumbClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { ActivatedRoute, NavigationEnd, Router, Event, NavigationStart } from '@angular/router';
import { ContentHeaderService } from './content-header.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.less'],
  standalone: false
})
export class ContentHeaderComponent implements OnInit, OnDestroy {

  @Input()
  showContentHeader: boolean = false;

  @Input()
  title: string = 'Dashboard';

  @Input()
  subtitle: string = '...';

  @Input()
  contentsPath: ContentPath[] = [];

  @Input()
  contentId: string = '';

  loading: boolean = false;

  private subs = new Subscription();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private contentHeaderService: ContentHeaderService
  ) { }

  ngOnInit() {
    this.subs.add(
      this.contentHeaderService.getState().subscribe((state) => {
        this.title = state.title;
        this.subtitle = state.subtitle;
        this.showContentHeader = state.showContentHeader;
        this.loading = state.loading;
      })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onBreadcrumbClick(args: BreadcrumbClickEventArgs) {
    args.cancel = true;

    console.log(args.item.url)

    if (args.item.url) {
      this.router.navigate([args.item.url], { relativeTo: this.activatedRoute });
    }
  }

}
